import { gql } from 'graphql-tag';

export const GET_ALL_DISCLAIMERS = gql`
  query {
    getAllQsgDisclaimers {
      disclaimers {
        disclaimerId
        disclaimerType
        disclaimerContent {
          html
          markdown
        }
      }
    }
  }
`;

export const GET_SECTION_BY_PATH = gql`
  query ($path: String!) {
    getQsgSectionByPath(path: $path) {
      section {
        _path
        sectionId
        sectionName
        sectionTitle {
          html
          plaintext
          markdown
        }
        sectionDescription
        sectionKeywords {
          plaintext
        }
        sectionFooter {
          html
          plaintext
          markdown
        }
        features {
          __typename
          ... on QsgIconlistFeatureModel {
            _id
            _path
            items {
              html
              markdown
              plaintext
            }
            splitAtNumber
          }
          ... on QsgContentFeatureModel {
            _id
            _path
            title {
              html
              plaintext
              markdown
            }
            content {
              html
              plaintext
              markdown
            }
            media {
              mediaType
              asset {
                _publishUrl
                type
              }
              forceMaxWidth
              altText
              caption {
                html
                plaintext
                markdown
              }
              posterImage {
                _publishUrl
                type
              }
              externalUrl
              autoplay
              loop
              muted
              showControls
            }
            layout
            layoutIndex
            layoutColumnBreakSpecifier
            layoutColumnBreakSpecifierIndex
            isLayoutDisclaimer
            flowTextBelowMedia
            centerMediaAroundLayout
            centerTextAroundLayout
          }
          ... on QsgMediaFeatureModel {
            _id
            _path
            mediaType
            asset {
              _publishUrl
              type
            }
            forceMaxWidth
            altText
            caption {
              html
              plaintext
              markdown
            }
            posterImage {
              _publishUrl
              type
            }
            externalUrl
            autoplay
            loop
            muted
            showControls
          }
          ... on QsgDisclaimerFeatureModel {
            _id
            _path
            disclaimerId
            disclaimerType
            disclaimerContent {
              html
              plaintext
              markdown
            }
          }
        }
        subsections {
          _path
          sectionId
          sectionName
        }
      }
    }
  }
`;

export const GET_QSG_NAVIGATION = gql`
  query ($year: String!, $modelId: String!) {
    getQsgNavigation(year: $year, modelId: $modelId) {
      navigation {
        _path
        modelId
        modelYear
        modelName
        coverImage {
          _publishUrl
          type
        }
        jellybean {
          _publishUrl
          type
        }
        pdfFile {
          _publishUrl
          type
        }
        sections {
          _path
          sectionId
          sectionName
          sectionTitle {
            html
            markdown
          }
          sectionDescription
          sectionKeywords {
            plaintext
          }
          features {
            _id
            _path
          }
          subsections {
            _path
            sectionId
            sectionName
            sectionTitle {
              html
              markdown
            }
            sectionDescription
            sectionKeywords {
              plaintext
            }
            features {
              _id
              _path
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_MODELS = gql`
  query {
    getAllQsgModels {
      models {
        modelId
        modelName
        modelYear
      }
    }
  }
`;

export const GET_QSG_SEARCH_RESULTS = gql`
  query (
    $year: String!
    $modelId: String!
    $searchTerm: String!
    $page: Int
    $limit: Int
  ) {
    getQsgSearchResults(
      year: $year
      modelId: $modelId
      searchTerm: $searchTerm
      page: $page
      limit: $limit
    ) {
      results {
        chain {
          sectionId
          sectionName
          sectionTitle {
            html
            plaintext
          }
        }
        sectionId
        sectionName
        sectionTitle {
          html
          plaintext
        }
        resultTitle {
          html
          plaintext
        }
        resultContent {
          html
          plaintext
          trimmed
        }
      }
      totalCount
      page
      limit
      hasMore
    }
  }
`;

export const GET_MODELS_BY_YEAR = gql`
  query GetModels($year: String!) {
    getQsgModelsByYear(year: $year) {
      modelNames
    }
  }
`;

export const GET_MODEL_YEARS = gql`
  query {
    getQsgModelYears {
      modelYears
    }
  }
`;

export const GET_QSG_BY_YEAR_AND_MODEL = gql`
  query ($year: String!, $modelId: String!) {
    getQsgByYearAndModel(year: $year, modelId: $modelId) {
      guides {
        _path
        modelId
        modelYear
        modelName
        coverImage {
          _publishUrl
          type
        }
        jellybean {
          _publishUrl
          type
        }
        pdfFile {
          _publishUrl
          type
        }
        sections {
          _path
          sectionId
          sectionName
          sectionTitle {
            html
            plaintext
            markdown
          }
          sectionDescription
          sectionKeywords {
            plaintext
          }
          sectionFooter {
            html
            plaintext
            markdown
          }
          features {
            __typename
            ... on QsgIconlistFeatureModel {
              _id
              _path
              items {
                html
                markdown
                plaintext
              }
              splitAtNumber
            }
            ... on QsgContentFeatureModel {
              _id
              _path
              title {
                html
                plaintext
                markdown
              }
              content {
                html
                plaintext
                markdown
              }
              media {
                __typename
                mediaType
                asset {
                  _publishUrl
                  type
                }
                externalUrl
                caption {
                  html
                  plaintext
                  markdown
                }
                forceMaxWidth
                altText
                posterImage {
                  _publishUrl
                  type
                }
                autoplay
                loop
                muted
                showControls
              }
              layout
              layoutIndex
              layoutColumnBreakSpecifier
              layoutColumnBreakSpecifierIndex
              flowTextBelowMedia
              centerMediaAroundLayout
              centerTextAroundLayout
            }
            ... on QsgMediaFeatureModel {
              _id
              _path
              mediaType
              asset {
                _publishUrl
                type
              }
              externalUrl
              caption {
                html
                plaintext
                markdown
              }
              forceMaxWidth
              altText
              posterImage {
                _publishUrl
                type
              }
              autoplay
              loop
              muted
              showControls
            }
            ... on QsgDisclaimerFeatureModel {
              _id
              _path
              disclaimerId
              disclaimerType
              disclaimerContent {
                html
                plaintext
                markdown
              }
            }
          }
          subsections {
            _path
            sectionId
            sectionName
            sectionTitle {
              html
              plaintext
              markdown
            }
            sectionDescription
            sectionKeywords {
              plaintext
            }
            sectionFooter {
              html
              plaintext
              markdown
            }
            features {
              __typename
              ... on QsgIconlistFeatureModel {
                _id
                _path
                items {
                  html
                  markdown
                  plaintext
                }
                splitAtNumber
              }
              ... on QsgContentFeatureModel {
                _id
                _path
                title {
                  html
                  plaintext
                  markdown
                }
                content {
                  html
                  plaintext
                  markdown
                }
                media {
                  __typename
                  mediaType
                  asset {
                    _publishUrl
                    type
                  }
                  externalUrl
                  caption {
                    html
                    plaintext
                    markdown
                  }
                  forceMaxWidth
                  altText
                  posterImage {
                    _publishUrl
                    type
                  }
                  autoplay
                  loop
                  muted
                  showControls
                }
                layout
                layoutIndex
                layoutColumnBreakSpecifier
                layoutColumnBreakSpecifierIndex
                flowTextBelowMedia
                centerMediaAroundLayout
                centerTextAroundLayout
              }
              ... on QsgMediaFeatureModel {
                _id
                _path
                mediaType
                asset {
                  _publishUrl
                  type
                }
                externalUrl
                caption {
                  html
                  plaintext
                  markdown
                }
                forceMaxWidth
                altText
                posterImage {
                  _publishUrl
                  type
                }
                autoplay
                loop
                muted
                showControls
              }
              ... on QsgDisclaimerFeatureModel {
                _id
                _path
                disclaimerId
                disclaimerType
                disclaimerContent {
                  html
                  plaintext
                  markdown
                }
              }
            }
          }
        }
      }
    }
  }
`;
